import { GuestCartInputDataV2 } from "@/components/graphql/types/globalTypes";
import { NEXT_PUBLIC_CART_SERVICE_BASE_URL } from "@/libs/constants/auth";
import {fetchUtil} from "@/libs/fetch";
import { saveCartV2_saveCartV2_data } from "@/components/graphql/types/saveCartV2";
import { v4 as uuidv4 } from "uuid";
import { isBrowser } from "@/helpers/isBrowser";

export interface GuestSaveCartPayload {
  cartInputV2: GuestCartInputDataV2;
}

export interface GuestSaveCartResponse {
  success: boolean;
  message?: string;
  data?: saveCartV2_saveCartV2_data & { id: string };
}

export const guestSaveCartApi = async (
  guestCartInputDataV2: GuestCartInputDataV2
): Promise<GuestSaveCartResponse> => {
  const url = `${NEXT_PUBLIC_CART_SERVICE_BASE_URL}/public/guest/save-cart`;
  if (!guestCartInputDataV2.id) {
    const tempCartId = `temp-${uuidv4()}`;
    isBrowser() && localStorage?.setItem("guestCartId", tempCartId);
    guestCartInputDataV2.id = tempCartId;
  }
  const payload: GuestSaveCartPayload = {
    cartInputV2: guestCartInputDataV2,
  };

  try {
    const response = await fetchUtil({
      url,
      method: "POST",
      body: payload,
      useToken: false,
    });
    return response;
  } catch (error) {
    console.error("Failed to save guest cart:", error);
    throw error;
  }
};
